export default function riskUniqueNameDirective(
  $q,
  riskDataService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const customerRiskId = attributes.customerRiskId || -1;
    ngModel.$asyncValidators.riskUniqueName = (modelValue) => {
      const defer = $q.defer();
      riskDataService.checkRiskNameExists(
        modelValue,
        customerRiskId
      ).then((data) => {
        if (data && !data.data.result) {
          defer.resolve();
        } else {
          defer.reject();
        }
      }).catch(defer.reject);
      return defer.promise;
    };
  }
}

export const name = 'riskUniqueName';

riskUniqueNameDirective.$inject = [
  '$q',
  'riskDataService'
];
